// @flow
/**
 * sendFreeAnswersToRAT
 * https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=1746667214
 */
import {
  RAT_ACCOUNT_ID_FOR_REX,
  isRATAvailable,
  getRatAccountId,
} from './sendRAT';

export const sendFreeAnswersToRAT = ({
  cId,
  npsValue,
  formInputValue = '',
}: {
  cId: string,
  npsValue: string,
  formInputValue: string,
}) => {
  if (isRATAvailable()) {
    const ratConfig = {
      accountId: RAT_ACCOUNT_ID_FOR_REX,
      serviceId: 1,
      includeInput: true,
      pData: {
        compid: ['answer_transmission'],
      },
      cpData: {
        campaign_acc: getRatAccountId(),
        campaign_id: cId,
        campaign_solution: 'in_page_survey',
        campaign_answer_nps: npsValue,
        campaign_answer_fa: encodeURIComponent(formInputValue),
      },
      options: ['url', 'ua'],
      eventType: 'async',
    };

    try {
      RAT.addCustomEvent(ratConfig);
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
};

export default sendFreeAnswersToRAT;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/sendFreeAnswersToRAT.js